import { IDocumentObjectsInformationObjectOption } from "./IDocumentObjectsInformation";

export class DocumentObjectsInformationObjectOption implements IDocumentObjectsInformationObjectOption {
  text: string;
  value?: number;
}
